module.exports = __webpack_public_path__ + "media/images/user_placeholder-0b982e1a.svg";